// export const baseUrl = 'http://localhost:4001'
export const baseUrl = 'https://api.hulluware.com'
export const TOKEN_KEY = 'hwtoken'
export const path = {
    newStudents: '/api/administrator/students',
    signin: '/api/common/login?type=admin',
    fetchCategories: '/api/administrator/categories',
    fetchSubCategories: '/api/administrator/sub-categories',
    uploadFile: '/api/administrator/upload-file',
    addCategory: '/api/administrator/add-category',
    editCategory: '/api/administrator/edit-category',
    deleteCategory: '/api/administrator/delete-category',
    addSubCategory: '/api/administrator/add-sub-category',
    editSubCategory: '/api/administrator/edit-sub-category',
    deleteSubCategory: '/api/administrator/delete-sub-category',
    getInstructors: '/api/administrator/instructors',
    createInstructor: '/api/administrator/add-instructor',
    addCourse: '/api/administrator/add-course', 
    getCourses: '/api/administrator/courses',
    getSections: '/api/administrator/sections',
    addSection: '/api/administrator/add-section',
    addSubSection: '/api/administrator/sub-section',
    uploadStreamFile: '/api/administrator/upload-stream-file',
    getVideoStream: '/api/administrator/get-video-stream',  
    uploadSectionMaterial: '/api/administrator/upload-material',
    getSectionMaterials: '/api/administrator/get-materials',
    subSection: '/api/administrator/sub-section',
    readyState: '/api/administrator/readystate-course',
    users: '/api/administrator/users',
    enrollments: '/api/administrator/enrollments',
    dashboard: '/api/administrator/dashboard',
    upgradeSeller: '/api/administrator/upgrade-seller',
    withdrawal: '/api/administrator/withdrawal',
    finance: '/api/administrator/finance',
    cashout: '/api/administrator/cashout',
    sellerStatus: '/api/administrator/seller-status'
}
export const k = 'kTjNagFc1lXwCFdQQWq7aySUxBPO6rqTFLvGBPa4smU=';
export const i = 'G/I+23afErLNC41YVfoT5A==';